// extracted by mini-css-extract-plugin
export default {"cardCompanyStack":"CardCompanyPage_cardCompanyStack__DHNMU"};